import { FC, useContext, useState } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';

import Select, { SelectChangeEvent } from '@mui/material/Select';
import { AppContext } from '../../context/AppContext';
import SearchBarSpecialtySelect from '../search-bar/search-bar-specialty-select/SearchBarSpecialtySelect';
import { DirectoryListType } from '../directory-list/DirectoryList';
import SearchBarButton from '../search-bar/search-bar-button/SearchBarButton';
import SearchBarCriteriaInput from '../search-bar/search-bar-criteria-input/SearchBarCriteriaInput';
import SearchBarLocationInput from '../search-bar/search-bar-location-input/SearchBarLocationInput';
import SearchBarDistanceSelect from '../search-bar/search-bar-distance-select/SearchBarDistanceSelect';
import CustomAlert from '../alerts';
import { checkValidZip, evaluateIsDisabled } from '../../lib/util';
import { defaultAppState } from '../../context/DefaultAppState';
import { useHistory, useParams } from 'react-router-dom';

const SearchMobile: FC = () => {
  const history = useHistory();
  const { isDisabled } = useContext(AppContext);
  const [severityAlert, setSeverityAlert] = useState<'error' | 'info' | 'success' | 'warning'>('error');
  const messageAlert = 'The Zip Code format is wrong, please use a correct format, example: 12345 or 12345-1234.';
  const { directory } = useParams<{ location: string; directory: string; specialty: string }>();

  const profesionalList = [
    {
      label: 'Doctor',
      value: 'doctor'
    },
    {
      label: 'Pharmacy',
      value: 'pharmacy'
    },
    {
      label: 'Dentist',
      value: 'dentist'
    },
    {
      label: 'Hospital, Facility, or Other Services',
      value: 'hospital, facility, or other service'
    },
    {
      label: 'Phone',
      value: 'phone'
    },
    {
      label: 'All',
      value: 'all'
    },
    {
      label: 'None',
      value: 'none'
    }
  ];
  // const [specialist, setSpecialist] = useState(specialty ? specialty : '');
  const [professional, setProfessional] = useState(directory || 'doctor'); // [professional, setProfessional
  const appContext = useContext(AppContext);
  // const categories = mapCategoriesByDirectory(appContext);

  const handleProfessionalChange = (event: SelectChangeEvent) => {
    history.push('/');

    // TODO: convert this to custom hook or global function
    appContext.updateSelectedSpecialty('');
    appContext.updateName('');
    appContext.updateLocation('');
    appContext.updateDistance({
      name: 'Select Distance',
      distance: -1
    });
    appContext.updateIsDisabled(false);

    setProfessional(event.target.value as string);
    switch (event.target.value) {
      case DirectoryListType.doctor:
        appContext.updateListType(DirectoryListType.doctor);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.facility:
        appContext.updateListType(DirectoryListType.facility);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.pharmacy:
        appContext.updateListType(DirectoryListType.pharmacy);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.dentist:
        appContext.updateListType(DirectoryListType.dentist);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.hearingAid:
        appContext.updateListType(DirectoryListType.hearingAid);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.transportation:
        appContext.updateListType(DirectoryListType.transportation);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.phone:
        appContext.updateListType(DirectoryListType.phone);
        appContext.updateSelected(true);
        break;
      case DirectoryListType.all:
        appContext.updateListType(DirectoryListType.all);
        appContext.updateSelected(true);
        break;
      default:
        appContext.updateListType(DirectoryListType.none);
        appContext.updateSelected(false);
        break;
    }
  };

  return (
    <div>
      <Box sx={{ minWidth: 120 }}>
        <FormControl fullWidth variant="filled" style={{ marginBottom: 15 }}>
          <InputLabel id="specialist-select">Professionals</InputLabel>
          <Select
            labelId="specialist-select"
            id="specialist-select"
            value={professional}
            label="Profesionals"
            onChange={handleProfessionalChange}
            className="bg-white"
            style={{ backgroundColor: '#fff', borderRadius: '5px' }}
          >
            {profesionalList.map((item) => (
              <MenuItem key={item.value} value={item.value}>
                {item.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <SearchBarSpecialtySelect />
        <div style={{ marginBottom: 15 }}>{''}</div>
        <SearchBarCriteriaInput />
        <SearchBarLocationInput />
        <SearchBarDistanceSelect />

        {/* <FormControl variant="filled" fullWidth style={{ marginBottom: 15 }}>
          <TextField id="zipCode" label="Zip code, City or State" variant="filled" />
        </FormControl>

        <FormControl variant="filled" fullWidth style={{ marginBottom: 15 }}>
          <TextField id="doctorName" label="Doctor name, practice, facility or specialty" variant="filled" />
        </FormControl> */}

        {/* <button type="button" className="button-search-mobile">
          Search
        </button> */}
        <SearchBarButton />
      </Box>
      {isDisabled && <CustomAlert severity={severityAlert} message={messageAlert} />}
    </div>
  );
};

export default SearchMobile;
